import { Injectable } from "@angular/core";
import { Employee } from "../models/employee.model";
import { ApiService } from "./api.service";
import { Observable } from "rxjs/Rx";
import { Pagination } from "../models/pagination.model";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";

@Injectable()
export class EmployeeService {

    constructor(private api: ApiService) {
    }

    getByLot(lotId: number, params): Observable<Pagination> {
        return this.api.get('lots/' + lotId + '/employees?' + params);
    }

    find(employeeId: number): Observable<Employee> {
        return this.api.get('employees/' + employeeId);
    }

    getDocuments(employeeId: number, params) {
        return this.api.get('employees/' + employeeId + '/download-documents?' + params);
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/employee.service.ts